import React from 'react';
import './ColorKey.css';

const ColorKey = () => {
  return (
    <div className='color-pairs'>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#FF8C00" />
        </svg>
        <p className="color-key-language">Javascript</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#FF1493" />
        </svg>
        <p className="color-key-language">HTML</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#A62A2A" />
        </svg>
        <p className="color-key-language">CSS</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#FFFF54" />
        </svg>
        <p className="color-key-language">SCSS</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#00BFFF" />
        </svg>
        <p className="color-key-language">Java</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#00FF00" />
        </svg>
        <p className="color-key-language">Swift</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#800000" />
        </svg>
        <p className="color-key-language">C++</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#FF00FF" />
        </svg>
        <p className="color-key-language">Python</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#800080" />
        </svg>
        <p className="color-key-language">Ruby</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#2F4F4F" />
        </svg>
        <p className="color-key-language">Shell</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#7FFFD4" />
        </svg>
        <p className="color-key-language">TypeScript</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#6495ed" />
        </svg>
        <p className="color-key-language">PHP</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#D2B48C" />
        </svg>
        <p className="color-key-language">C#</p>
      </section>
      <section className="color-key-set">
        <svg className="color-key-seed" viewBox="-150 -150 300 150">
          <path d='M0,-150 C30,-110 40,-80 0,0 C-40,-80 -30,-110 0,-150' fill="#228B22" />
        </svg>
        <p className="color-key-language">C</p>
      </section>
    </div>
  )
}

export default ColorKey;
